import { useContext, useEffect, useState } from "react";
import { ContextType, LabContext } from ".";
import { Edit, Done, Cancel } from "@mui/icons-material";
import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TextField,
  IconButton,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import { AbnormalFlagType, LabDataType, LabResultType } from "../type";
import { headings } from "./LabResult";
import { useQuery } from "react-query";
import { getAbnormalFlag, getLabResult } from "../services";
import { ResponseType } from "../../../Types/ServicesType/servicesType";
import { useParams } from "react-router-dom";
import { clinicId } from "../../../constants";
import useSaveLabResult from "../hook/useSaveLabResult";
import { dateFormat } from "./SaveSpecimendate";
import dayjs from "dayjs";
import usePopup from "../../../hooks/usePopup";
import useAuthentication from "@hooks/useAuthentication";

function LabTemplateEdit() {
  const { encounterId } = useParams();
  const { showSnackbar } = usePopup();
  const {user} = useAuthentication()
  const {
    resultView,
    labData,
    setLabData,
    checkAbnormalFlag,
    setCheckAbnormalFlag,
    setIsResultSaved,
    isResultSaved,
    editData,
    setEditData
  } = useContext(LabContext) as ContextType;
  const [edit, setEdit] = useState<{
    data: LabDataType | null;
    index: number;
  }>({
    data: null,
    index: -1,
  });

  const onSuccess = (
    result: ResponseType<{ labItems: LabResultType[]; totalCount: number }>
  ) => {
    if (result.responseIndicator == "success") {
      setIsResultSaved(Boolean(result?.response?.labItems?.length))
      // console.log("result?.response?.labItems?.length",result?.response?.labItems?.length)
      if (Boolean(result?.response?.labItems?.length)) {
        console.log("api called------->")
        const data: LabDataType[] = [];
        result?.response?.labItems?.forEach((labField, index) => {
          data.push({
            _userId: 0,
            abnormalFlagId: labField.abnormalFlagCode,
            abnormalFlagName: labField.abnormalFlag,
            name: labField.fieldName,
            value: String(labField.fieldValue || "0"),
            unit: labField.fieldUnit,
            range: String(labField.fieldRange),
            specimenReceivedDateTime: labField.specimenReceivedDateTime || dayjs().format(dateFormat),
            clinicId,
            createdById: Number(user?.userId),
            encounterId: Number(encounterId),
            labResultId: labField.labResultId,
            labRequestId: resultView?.labId || 0,
            templateId: labField.templateId,
            ip: "",
            type: "Result",
            valueType: dayjs(
              labField.specimenReceivedDateTime || dayjs().format(dateFormat),
              dateFormat
            ).format("DD/MM/YYYY"),
            obsLabId: labField.obsLabId,
          });
          if (!Boolean(labField.abnormalFlagCode)) {
            setCheckAbnormalFlag((prev: any) => ({
              ...prev,
              [`${index}`]: true,
            }));
          }
        });
        // console.log(result?.response?.labItems[0]?.specimenReceivedDateTime)
        const specimenReceivedDateTime =
          result?.response?.labItems[0]?.specimenReceivedDateTime ||
          labData.specimenReceivedDateTime;
        setLabData({ specimenReceivedDateTime, data });
      }
    }
  };

  const {isLoading: labResultLoading, refetch } = useQuery(
    ["getLabResult", resultView],
    async () =>
      await getLabResult({
        labId: resultView?.labId as number,
        pageNo: 0,
        pageNumber: 0,
        pageSize: 25,
        sortField: "",
        sortOrder: "asc",
      }),
    {
      refetchOnWindowFocus: false,
      onSuccess,
    }
  );

  const successFunction = () => {
    setEdit({ data: null, index: -1 });
    refetch();
  };

  const { mutate: save, isLoading: saveLoading } =
    useSaveLabResult(successFunction);

  const { data: abnormalFlags, isLoading: abnormalFlagsLoading } = useQuery(
    ["getAbnormalFlag"],
    getAbnormalFlag,
    {
      refetchOnWindowFocus: false,
    }
  );

  const handleValueChange = (value: string, index: number) => {
    if (editData && editData[index]) {
      setEditData((prev) => ({
        ...prev,
        [index]: {
          abnormalFlagId: editData[index].abnormalFlagId || 0,
          abnormalFlagName: editData[index].abnormalFlagName || "",
          value,
        },
      }));
    } else {
      setEditData((prev) => ({
        ...prev,
        [index]: {
          abnormalFlagId: 0,
          abnormalFlagName: "",
          value,
        },
      }));
    }
  };

  const handleAbnormalFlagChange = (
    selected: AbnormalFlagType | null,
    index: number
  ) => {
   if(isResultSaved){
       if (!Boolean(selected) && !Boolean(checkAbnormalFlag[`${index}`])) {
      setCheckAbnormalFlag((prev: any) => ({
        ...prev,
        [`${index}`]: true,
      }));
    } else {
      const flagUpdate = {
        ...checkAbnormalFlag,
      };
      delete flagUpdate[`${index}`];
      setCheckAbnormalFlag(flagUpdate);
    }
   }
    if (editData && editData[index]) {
      setEditData((prev) => ({
        ...prev,
        [index]: {
          ...editData[index],
          abnormalFlagId: selected?.abnormalFlag_id || 0,
          abnormalFlagName: selected?.abnormalFlag_Name || "",
        },
      }));
    } else {
      setEditData((prev) => ({
        ...prev,
        [index]: {
          value: "0",
          abnormalFlagId: selected?.abnormalFlag_id || 0,
          abnormalFlagName: selected?.abnormalFlag_Name || "",
        },
      }));
    }
  };

  const handleSaveFieldData = (index: number, newData: LabDataType[]) => {
    setLabData((prev) => ({ ...prev, data: newData }));
    setEdit({ data: null, index: -1 });
    if (Boolean(newData[index].abnormalFlagId)) {
      const updated = { ...checkAbnormalFlag };
      if (updated[`${index}`]) {
        delete updated[`${index}`];
      }
      setCheckAbnormalFlag(updated);
    } else {
      setCheckAbnormalFlag((prev: any) => ({ ...prev, [`${index}`]: true }));
    }
  };

  const handleSave = (index: number) => {
    const newData = [...labData.data];
   if(editData){
    newData[index] = {
      ...newData[index],
      ...editData[index]
    };
   }
    if (isResultSaved) {
      if (Boolean(Object.entries(checkAbnormalFlag)?.length)) {
        showSnackbar({
          message: "Please enter Abnormal flags !",
          open: true,
          variant: "warning",
          duration: 4000,
        });
      } else {
        save([{...newData[index]}]);
      }
    } else {
      handleSaveFieldData(index, newData);
    }
  };

  const handleEdit = (data: LabDataType, index: number) => {
    setEdit({ data, index });
    setEditData((prev) => ({
      ...prev,
      [index]: {
        value: data.value,
        abnormalFlagId: data.abnormalFlagId || 0,
        abnormalFlagName: data.abnormalFlagName || "",
      },
    }));
  };
useEffect(()=>{
  console.log(labData.specimenReceivedDateTime)
return ()=>{
   setEditData({})
   setEdit({ data: null, index: -1 });
}
},[])
  return (
    <div>
      <Table size="small">
        <TableHead
          sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
        >
          {headings?.map((item: string) => (
            <TableCell
              sx={(theme) => ({ color: theme.palette.background.paper })}
              key={item}
            >
              {item}
            </TableCell>
          ))}
        </TableHead>
        <CustomTableBody
          alert={"No Items"}
          dataLoading={labResultLoading && Boolean(isResultSaved)}
          isData={Boolean(labData?.data?.length)}
          totalSpan={{ col: headings.length, row: 3 }}
        >
          {labData?.data?.map((data, index) => {
            return (
              <TableRow key={index}>
                <TableCell width={65}>{index + 1}</TableCell>
                <TableCell width={200}>{data.name}</TableCell>
                <TableCell width={150}>
                  {Boolean(
                    index == edit?.index || checkAbnormalFlag[`${index}`]
                  ) ? (
                    <TextField
                      inputProps={{ "data-index": index }}
                      defaultValue={
                        editData ? (editData[index]?.value || "0") : null
                      }
                      onChange={(e) => {
                        handleValueChange(e.target?.value, index);
                      }}
                      label="Result Value"
                      variant="standard"
                    />
                  ) : (
                    data.value
                  )}
                </TableCell>
                <TableCell width={70}>{data.unit}</TableCell>
                <TableCell width={70}>{data.range}</TableCell>
                <TableCell>
                  {Boolean(
                    index == edit?.index || checkAbnormalFlag[`${index}`]
                  ) ? (
                    <Autocomplete
                      loading={abnormalFlagsLoading}
                      value={{
                        abnormalFlag_id: editData
                          ? editData[index]?.abnormalFlagId || 0
                          : 0,
                        abnormalFlag_Name: editData
                          ? editData[index]?.abnormalFlagName || ""
                          : "",
                      }}
                      options={abnormalFlags?.response || []}
                      onChange={(_, value) => {
                        handleAbnormalFlagChange(value, index);
                      }}
                      renderInput={(params) => (
                        <TextField
                          variant="standard"
                          {...params}
                          label={<span>Select Abnormal flag <span className="text-red-500">*</span></span>}
                        />
                      )}
                      getOptionLabel={(option) => option.abnormalFlag_Name}
                      isOptionEqualToValue={(option, value) =>
                        option.abnormalFlag_id === value.abnormalFlag_id
                      }
                    />
                  ) : (
                    data.abnormalFlagName
                  )}
                </TableCell>
                <TableCell className="cursor-pointer" width={150}>
                  {!Boolean(
                    index == edit?.index || checkAbnormalFlag[`${index}`]
                  ) && (
                    <IconButton
                      onClick={() => {
                        handleEdit(data, index);
                      }}
                    >
                      <Edit color="primary" />
                    </IconButton>
                  )}
                  {Boolean(
                    index == edit?.index || checkAbnormalFlag[`${index}`]
                  ) && (
                    <>
                      <IconButton
                        disabled={saveLoading}
                        onClick={() => {
                          handleSave(index);
                        }}
                      >
                        {edit?.index == index && saveLoading ? (
                          <CircularProgress size={18} />
                        ) : (
                          <Done color="primary" />
                        )}
                      </IconButton>

                      <IconButton
                        disabled={saveLoading}
                        onClick={() => {
                          setEdit({ data: null, index: -1 });
                        }}
                      >
                        <Cancel color="error" />
                      </IconButton>
                    </>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </CustomTableBody>
      </Table>
    </div>
  );
}

export default LabTemplateEdit;
